export default {
  title: "شركات الشحن",
  subtitle: "إدارة شركات الشحن",
  
  addNew: "إضافة شركة شحن جديدة",
  createShippingCompany: "إنشاء شركة شحن",
  editShippingCompany: "تعديل شركة الشحن",
  deleteShippingCompany: "حذف شركة الشحن",
  
  fields: {
    name: "اسم الشركة",
    code: "رمز الشركة",
    contactPerson: "الشخص المسؤول",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    address: "العنوان",
    website: "الموقع الإلكتروني",
    trackingUrl: "رابط التتبع",
    isActive: "نشط",
    shippingRates: "أسعار الشحن",
    deliveryTime: "وقت التسليم",
    coverage: "منطقة التغطية",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث",
    maxWeight: "الحد الأقصى للوزن (باوند)",
    maxDimension: "الحد الأقصى للأبعاد (بوصة)",
    fuelSurchargeRate: "نسبة رسوم الوقود",
    complexSurchargeRate: "نسبة الرسوم المعقدة",
    dwDivisor: "مقسم الوزن الحجمي",
    insuranceRate: "نسبة التأمين",
    dgFees: "رسوم البضائع الخطرة",
    pricingTable: "جدول الأسعار"
  },
  
  placeholders: {
    name: "أدخل اسم الشركة",
    code: "أدخل رمز الشركة",
    contactPerson: "أدخل اسم الشخص المسؤول",
    email: "أدخل البريد الإلكتروني",
    phone: "أدخل رقم الهاتف",
    address: "أدخل عنوان الشركة",
    website: "أدخل رابط الموقع الإلكتروني",
    trackingUrl: "أدخل قالب رابط التتبع",
    deliveryTime: "أدخل وقت التسليم (مثل: 2-3 أيام)",
    coverage: "أدخل منطقة التغطية",
    maxWeight: "أدخل الحد الأقصى للوزن",
    maxDimension: "أدخل الحد الأقصى للأبعاد",
    fuelSurchargeRate: "أدخل نسبة رسوم الوقود",
    complexSurchargeRate: "أدخل نسبة الرسوم المعقدة",
    dwDivisor: "أدخل مقسم الوزن الحجمي",
    insuranceRate: "أدخل نسبة التأمين",
    dgFees: "أدخل رسوم البضائع الخطرة"
  },
  
  messages: {
    createSuccess: "تم إنشاء شركة الشحن بنجاح",
    createError: "فشل في إنشاء شركة الشحن",
    updateSuccess: "تم تحديث شركة الشحن بنجاح",
    updateError: "فشل في تحديث شركة الشحن",
    deleteSuccess: "تم حذف شركة الشحن بنجاح",
    deleteError: "فشل في حذف شركة الشحن",
    deleteConfirm: "هل أنت متأكد من حذف شركة الشحن هذه؟",
    noShippingCompanies: "لا توجد شركات شحن",
    loadingShippingCompanies: "جاري تحميل شركات الشحن...",
    fetchError: "فشل في جلب شركات الشحن",
    templateDownloadSuccess: "تم تحميل القالب بنجاح",
    templateDownloadError: "فشل في تحميل القالب",
    importSuccess: "تم استيراد {{count}} إدخال سعر بنجاح",
    importReplaceSuccess: "تم استبدال جميع الأسعار بنجاح باستخدام {{count}} إدخال مستورد",
    importError: "فشل في استيراد الأسعار من ملف Excel",
    importEmpty: "لم يتم العثور على إدخالات أسعار صالحة في الملف",
    invalidFileType: "يرجى تحميل ملف Excel صالح (.xlsx أو .xls)"
  },
  
  validation: {
    nameRequired: "اسم الشركة مطلوب",
    codeRequired: "رمز الشركة مطلوب",
    emailFormat: "يرجى إدخال بريد إلكتروني صحيح",
    phoneFormat: "يرجى إدخال رقم هاتف صحيح",
    websiteFormat: "يرجى إدخال رابط موقع صحيح",
    trackingUrlFormat: "يرجى إدخال رابط تتبع صحيح",
    allFieldsRequired: "جميع الحقول مطلوبة"
  },
  
  table: {
    name: "الاسم",
    code: "الرمز",
    contactPerson: "المسؤول",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    deliveryTime: "وقت التسليم",
    coverage: "التغطية",
    status: "الحالة",
    actions: "الإجراءات",
    maxWeight: "الحد الأقصى للوزن",
    normalFast: "عادي سريع",
    normalEconomy: "عادي اقتصادي",
    dangerousFast: "خطرة سريع",
    dangerousEconomy: "خطرة اقتصادي",
    sourceCountry: "البلد المصدر",
    destinationCountry: "البلد الوجهة"
  },
  
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط",
    suspended: "معلق"
  },
  
  breadcrumbs: {
    shippingCompanies: "شركات الشحن",
    create: "إنشاء شركة شحن",
    edit: "تعديل شركة الشحن",
    view: "عرض شركة الشحن"
  },

  buttons: {
    submit: "إرسال",
    update: "تحديث",
    submitting: "جاري الإرسال...",
    updating: "جاري التحديث...",
    backToIndex: "العودة للقائمة",
    addPriceEntry: "إضافة سعر جديد",
    downloadTemplate: "تحميل القالب",
    importFromExcel: "استيراد من Excel",
    importing: "جاري الاستيراد..."
  }
};
